import type { DemoKey } from './keys';

export const id: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometri · 3D',
  'panel.figure': 'Bangun',
  'panel.dims': 'Dimensi',
  'panel.style': 'Tampilan',
  'panel.lines': 'Garis khusus',
  'style.body': 'Badan',
  'style.line': 'Garis',
  'style.cut': 'Potongan',
  'style.labels': 'Label titik sudut',
  'group.face': 'Diagonal sisi / garis pelukis',
  'group.space': 'Diagonal / sumbu / garis tengah',
  'split.label': 'Potongan',
  'btn.animate': 'Animasi',
  'btn.reset': 'Atur ulang',
  'hint.line1': 'Seret untuk memutar · Gulir untuk zoom',
  'hint.line2': 'Klik garis untuk memilih',
  'fig.cuboid': 'Balok',
  'fig.cube': 'Kubus',
  'fig.triPrism': 'Prisma segitiga',
  'fig.hexPrism': 'Prisma segi enam',
  'fig.tetrahedron': 'Tetrahedron',
  'fig.squarePyramid': 'Limas segi empat',
  'fig.cylinder': 'Tabung',
  'fig.cone': 'Kerucut',
  'fig.sphere': 'Bola',
  'fig.frustumPyramid': 'Limas terpancung',
  'fig.frustumCone': 'Kerucut terpancung',
  'dim.length': 'panjang',
  'dim.width': 'lebar',
  'dim.height': 'tinggi',
  'dim.side': 'sisi',
  'dim.radius': 'jari-jari',
  'dim.r1': 'jari-jari bawah',
  'dim.r2': 'jari-jari atas',
  'dim.sideBase': 'sisi alas',
  'dim.sideTop': 'sisi atas',
  'info.face': 'sisi',
  'info.center': 'lewat pusat',
  'info.diagonal': 'diagonal',
  'info.axial': 'diagonal aksial',
  'info.diameter': 'diameter',
  'info.generator': 'garis pelukis',
  'info.axis': 'sumbu',
  'info.height': 'tinggi',
  'info.median': 'median',
  'info.apothem': 'apotema',
  'info.diameterBase': 'diameter alas',
  'info.diameterTop': 'diameter atas',
};
